import { Compass } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, buttonVariants } from "@/design-system/components/ui";
import { PageHeader } from "@/components/layout/PageHeader";

/**
 * The catch-all 404. Rendered inside the AppShell so the sidebar, top bar,
 * and breadcrumbs stay in place — a wrong URL keeps the user oriented and
 * one click from where they meant to go.
 */
export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        eyebrow="Error 404"
        title="Page not found"
        description="We couldn't find the page you're looking for."
      />
      <Card className="flex flex-col items-center text-center py-space-7">
        <Compass
          size={40}
          strokeWidth={1.5}
          className="text-gold-shadow mb-space-3"
          aria-hidden
        />
        <h2 className="font-display font-bold text-h3 text-onyx m-0 mb-space-2 normal-case tracking-normal">
          This page doesn't exist
        </h2>
        <p className="text-body text-gray-mid m-0 max-w-reading">
          The page may have been moved or removed, or the link you followed may
          be incorrect. Check the address, or head back to the dashboard.
        </p>
        <div className="mt-space-4 flex flex-wrap items-center justify-center gap-space-3">
          <Link to="/" className={buttonVariants({ variant: "primary" })}>
            Go to dashboard
          </Link>
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Go back
          </Button>
        </div>
      </Card>
    </>
  );
}
